import { Component } from '@angular/core';

@Component({
    selector: 'error-page',
    template: require('./error500.html'),
})

export class ErrorPageComponent {
}
